import { useState, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useSelector } from 'react-redux';

export default function useCheckIdle(callback) {
    const [isIdle, setIsIdle] = useState(false);
    const isAPICallTriggered = useSelector(state => state.settings.isUsingAPICalls);

    useEffect(() => {
        callback();
    }, [isAPICallTriggered])

    //useEffect(() => {
    //  const interval = setInterval(() => {
    //    const rem = Math.ceil(getRemainingTime() / 1000);
    //    console.log(rem);
    //  }, 1000)

    //  return () => {
    //    clearInterval(interval)
    //  }
    //})

    const onIdle = () => {
        setIsIdle(true);
    }

    const onActive = () => {
        setIsIdle(false)
    }

    const onUserActive = () => {
        callback();
    }

    const { reset, getElapsedTime, start, /*getRemainingTime*/ } = useIdleTimer({
        onIdle,
        onActive,
        timeout: 1000 * 60 * process.env.REACT_APP_IDLE_TIMEOUT,
        throttle: 2000,
        events: ["click", "input", "select"],
        onAction: onUserActive,
    })

    return [isIdle, reset, getElapsedTime, start]
}
